import {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
// import ReactPaginate from 'react-paginate'
import './ApprovedRequests.css'
import {ApprovedSMS, PackagePost, PackageUpdate} from '../../models/Package'
import PackageService from '../../../api/super-admin/PackageService'

function ApprovedRequests() {
  const [showAddEditPopup, setShowAddEditPopup] = useState<boolean>(false)
  const [showDetailsPopup, setShowDetailsPopup] = useState<boolean>(false)
  const [approvedSMSList, setApprovedSMSList] = useState<ApprovedSMS[]>([] as ApprovedSMS[])
  const [companySMSDetail, setCompanySMSDetail] = useState<ApprovedSMS>({} as ApprovedSMS)

  // const [offset, setOffset] = useState<number>(0)
  // const [limit, setLimit] = useState<number>(10)
  // const [totalPages, setTotalPages] = useState<number>(0)

  useEffect(() => {
    getApprovedSMSList()
  }, [])

  const getApprovedSMSList = () => {
    PackageService.getApprovedSMSList().then(
      (res: any) => {
        if (res?.data?.success) {
          setApprovedSMSList(res?.data?.data)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
          setApprovedSMSList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
    // let data: any = {
    //   limit: limit,
    //   offset: offset,
    // }
    // PackageService.getApprovedSMSList(data).then(
    //   (res: any) => {
    //     if (res?.data?.success) {
    //       setApprovedSMSList(res?.data?.data)
    //       setTotalPages(Math.ceil(res?.data?.count / limit))
    //     } else {
    //       toast.error(res?.data?.message, {theme: 'dark'})
    //       setApprovedSMSList([])
    //     }
    //   },
    //   (err: any) => {
    //     toast.error(err?.response?.data?.message, {theme: 'dark'})
    //   }
    // )
  }

  // const handlePageChange = (selected: any) => {
  //   const newOffset = selected === 0 ? 0 : selected * limit
  //   let data = {
  //     limit: limit,
  //     offset: newOffset,
  //   }
  //   PackageService.getApprovedSMSList(data).then(
  //     (res: any) => {
  //       if (res?.data?.success) {
  //         setApprovedSMSList(res?.data?.data)
  //         setTotalPages(Math.ceil(res?.data?.count / limit))
  //         setOffset(newOffset)
  //       } else {
  //         toast.error(res?.data?.message, {theme: 'dark'})
  //         setApprovedSMSList([])
  //       }
  //     },
  //     (err: any) => {
  //       toast.error(err?.response?.data?.message, {theme: 'dark'})
  //     }
  //   )
  // }

  const handleViewDetails = (id: number) => {
    PackageService.getCompanySMSDetails(id).then(
      (res: any) => {
        if (res?.data?.success) {
          setCompanySMSDetail(res?.data?.data)
          setShowDetailsPopup(true)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handleStatusToggle = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PackageService.changeCompanySMSStatus(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getApprovedSMSList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  return (
    <>
      {/* Table */}
      <div className='col-lg-12' style={{marginTop: 25}} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Company Name</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Sender ID</span>
            </td>
            {/* <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Balance</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>SMS Limit</span>
            </td> */}
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Status</span>
            </td>
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {approvedSMSList.map(
            (approvedSMS: ApprovedSMS, index: number) =>
              (approvedSMS.status === 1 || approvedSMS.status === 2) && (
                <div
                  className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
                  key={index}
                  style={{marginBottom: 20, borderRadius: 5}}
                >
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.companyDetails.name}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.sender_id}
                    </span>
                  </td>
                  {/* <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.balance}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.sms_limit}
                    </span>
                  </td> */}
                  <td className='d-flex w-lg-25'>
                    <span
                      className={`fw-bold d-block fs-5 d-flex align-items-center ${
                        approvedSMS.status === 1 ? 'text-success' : 'text-danger'
                      }`}
                    >
                      {approvedSMS.status === 1 ? 'Enabled' : 'Disabled'}
                    </span>
                  </td>
                  <td className='d-flex justify-content-end w-lg-25'>
                    <button
                      style={{
                        backgroundColor: 'limegreen',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                      }}
                      type='button'
                      onClick={() => handleViewDetails(approvedSMS.id)}
                      className='btn btn-sm mx-1'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title='Details'
                    >
                      Details
                    </button>

                    {/* <button
                  onClick={() => handleDelete(packagee?.id)}
                  type='button'
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Delete'
                >
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                </button> */}
                    <div className='d-flex justify-content-end flex-shrink-0 mx-1'>
                      {approvedSMS.status === 1 && (
                        <div
                          className='d-flex align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title='Toggle Status'
                        >
                          <button
                            className='status-holder active-status'
                            onClick={() => handleStatusToggle(approvedSMS.id)}
                          >
                            <div className='d-flex align-items-center justify-content-end'>
                              <div className='active-user active-status-light'></div>
                            </div>
                          </button>
                        </div>
                      )}
                      {approvedSMS.status === 2 && (
                        <div
                          className='d-flex align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title='Toggle Status'
                        >
                          <button
                            className='status-holder pending-status'
                            onClick={() => handleStatusToggle(approvedSMS.id)}
                          >
                            <div className='d-flex align-items-center'>
                              <div className='active-user pending-status-light'></div>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </div>
              )
          )}

          {approvedSMSList.length === 0 && (
            <p
              className='text-dark fw-bold d-block fs-5 text-muted'
              style={{textAlign: 'center', marginTop: 150}}
            >
              No Approved SMS Requests Available
            </p>
          )}
        </div>
      </div>
      {/* Pagination */}
      {/* {totalPages > 0 && (
        <ReactPaginate
          previousLabel='Previous'
          nextLabel='Next'
          breakLabel='...'
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selected) => handlePageChange(selected.selected)}
          containerClassName='pagination'
          activeClassName='active'
        />
      )} */}
      {/* Add / Edit Popup */}
      {/* Details Popup */}
      {showDetailsPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='d-flex flex-row align-items-center justify-content-between w-100 mx-3'>
                <h5 style={{marginLeft:20}} className='modal-title'>Details</h5>
                <button
                  className='btn btn-close'
                  onClick={() => {
                    setShowDetailsPopup(false)
                  }}
                ></button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <form>
                  <div className='row mb-3'>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Company Name</label>
                      <input
                        className='form-control'
                        style={{backgroundColor: 'white', color: 'black'}}
                        value={companySMSDetail.companyDetails.name}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Sender ID</label>
                      <input
                        className='form-control'
                        style={{backgroundColor: 'white', color: 'black'}}
                        value={companySMSDetail.sender_id}
                        disabled
                      />
                    </div>
                    {/* <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Balance</label>
                      <input
                        className='form-control'
                        style={{backgroundColor: 'white', color: 'black'}}
                        value={companySMSDetail.balance}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>SMS Limit</label>
                      <input
                        className='form-control'
                        style={{backgroundColor: 'white', color: 'black'}}
                        value={companySMSDetail.sms_limit}
                        disabled
                      />
                    </div> */}
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Status</label>
                      <input
                        className='form-control'
                        style={{backgroundColor: 'white', color: 'black'}}
                        value={companySMSDetail.status === 1 ? 'Enabled' : 'Disabled'}
                        disabled
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ApprovedRequests
